
    var riot = require('riot')
    //src: starling/src/tags/modal-share/panel-presentation.html
riot.tag2('panel-presentation',
  '<div if="{getCardZeroState() || getWaypointsZeroState()}"> <h3 class="panel-presentation_title">Present your ideas!</h3> <p if="{getCardZeroState()}" class="panel-presentation_content"> Add cards and use waypoints to make a walk-through presentation of your map. </p> <p if="{!getCardZeroState() && getWaypointsZeroState()}" class="panel-presentation_content"> Use waypoints to make a walk-through presentation of your map. </p> <button if="{canModify}" class="Button Button--Secondary Button--Small" onclick="{handleCreatePresentation}"> Create a presentation </button> <button if="{getCardZeroState()}" class="Button Button--Small" onclick="{handleZeroCardLearnMore}"> Learn more </button> <button if="{!getCardZeroState()}" class="Button Button--Small" onclick="{handleZeroWaypointsLearnMore}"> Learn more </button> </div> <div if="{!getCardZeroState() && !getWaypointsZeroState()}" class="link-panel {!viewLinkAvailable() && \'link-panel--disabled\'}"> <header if="{canModify && viewLinkAvailable()}" class="link-panel_header"> <h3 class="link-panel_header_title">Anyone with this link can <b>{presentationPermission}</b> this map</h3> <div if="{editLinkAvailable()}" class="link-panel_menu"> <button if="{canModify}" class="link-panel_menu_button" onclick="{togglePermissionMenu}"> Can {presentationPermission} <svg class="link-panel_menu_icon"> <use xlink:href="#arrow-drop-down-icon"></use> </svg> </button> <div ref="permissionMenu" class="floating-menu floating-menu--bottom floating-menu--right floating-menu--small floating-menu--hidden"> <ul class="floating-menu_list"> <li class="floating-menu_item {isEditPermission() && \'floating-menu_item--iconless\'}" onclick="{togglePermission.bind(this, \'view\')}"> <svg if="{isViewPermission()}" class="floating-menu_icon" style="color: #0077f1;"> <use xlink:href="#check-icon"></use> </svg> <span class="floating-menu_label">Can view</span> </li> <li class="floating-menu_item {isViewPermission() && \'floating-menu_item--iconless\'}" onclick="{togglePermission.bind(this, \'edit\')}"> <svg if="{isEditPermission()}" class="floating-menu_icon" style="color: #0077f1;"> <use xlink:href="#check-icon"></use> </svg> <span class="floating-menu_label">Can edit</span> </li> </ul> </div> </div> </header> <header if="{canModify && !viewLinkAvailable()}" class="link-panel_header"> <svg width="16" height="16" style="color: #fea13a;"> <use xlink:href="#warning-icon"></use> </svg> <h3 class="link-panel_header_title">View-only link must be enabled share a presentation</h3> <button class="Button Button--Small" onclick="{enablePublicViewLink}"> Turn on view-only link </button> </header> <div class="link-panel_body"> <svg class="link-panel_icon"> <use xlink:href="#airplay-icon"></use> </svg> <div class="link-panel_content"> <h3 class="link-panel_title">Presentation link</h3> <p class="link-panel_description">Waypoint presentation will start when this link is opened</p> </div> </div> <div class="link-panel_url"> <input class="link-panel_input" type="text" riot-value="{presentationUrl()}" readonly disabled="{!viewLinkAvailable()}" ondblclick="{selectAll}" onclick="{selectAll}"> <button class="Button Button--Small" onclick="{copyLink}">Copy</button> </div> </div>',
  '',
  'class="modal-share_panel panel-presentation" onclick="{hidePermissionMenu}"', function(opts) {
'use strict';

var _this = this;

var _util = require('lib/util.js');

var _waypointsUi = require('lib/waypoints-ui');

var _waypointsUi2 = _interopRequireDefault(_waypointsUi);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var _opts = opts,
    canvas = _opts.canvas;
var store = canvas.store,
    access = canvas.access,
    people = canvas.people,
    config = canvas.config;

canvas.presentationSharePanel = this;

this.canModify = false;
this.presentationPermission = 'view';
this.isPermissionMenuVisible = false;

if (people) {
  var currentUser = people.currentUser;

  if (currentUser && currentUser.id === people.owner.id) {
    this.canModify = true;
  }
}

this.viewLinkAvailable = function () {
  return access.enablePublicViewLink;
};

this.editLinkAvailable = function () {
  return access.editKey && access.enablePublicEditLink;
};

this.getCardZeroState = function () {
  return store.getNodesSize() === 0;
};

this.handleZeroCardLearnMore = function (e) {
  e.preventDefault();

  _this.parent.dismiss();

  canvas.openSidebar('user-guide');
  canvas.userGuideTag.openItem('add-idea');
};

this.getWaypointsZeroState = function () {
  return _waypointsUi2.default.getWaypoints().length === 0;
};

this.handleZeroWaypointsLearnMore = function (e) {
  e.preventDefault();

  _this.parent.dismiss();

  canvas.openSidebar('user-guide');
  canvas.userGuideTag.openItem('waypoints');
};

this.handleCreatePresentation = function () {
  _this.parent.dismiss();
  canvas.toolsSidebarTag.activateTab({ tabTagName: 'waypoints-tab' });
};

this.togglePermission = function (permission) {
  _this.presentationPermission = permission;
  _this.update();
};

this.viewLinkAvailable = function () {
  return access && access.enablePublicViewLink;
};

this.editLinkAvailable = function () {
  return access.editKey && access.enablePublicEditLink;
};

this.isViewPermission = function () {
  return _this.presentationPermission === 'view';
};

this.isEditPermission = function () {
  return _this.presentationPermission === 'edit';
};

this.presentationLinkAvailable = function () {
  if (_this.isViewLink()) {
    return _this.viewLinkAvailable();
  } else {
    return _this.editLinkAvailable();
  }
};

this.enableViewOnlyLink = function () {
  canvas.linkSharePanel.toggleViewLink();
  _this.update();
};

this.presentationUrl = function () {
  if (_this.presentationPermission === 'edit') {
    return config.site_url + '/maps/' + access.publicIdentifier + '/edit/' + access.editKey + '?present=1';
  } else {
    return config.site_url + '/maps/' + access.publicIdentifier + '?present=1';
  }
};

this.selectAll = function (_ref) {
  var target = _ref.target;

  target.select();
};

this.copyLink = function (_ref2) {
  var target = _ref2.target;
  var textContent = target.textContent;

  target.textContent = 'Copied';
  setTimeout(function () {
    return target.textContent = textContent;
  }, 3000);

  (0, _util.copyToClipboard)({ text: target.previousElementSibling.value });
};

this.enablePublicViewLink = function () {
  access.enablePublicViewLink = !_this.viewLinkAvailable();
  _this.updateMapShareSettings({ field: 'view', on: _this.viewLinkAvailable() });
  _this.update();
};

this.updateMapShareSettings = function (_ref3) {
  var field = _ref3.field,
      on = _ref3.on;

  operation.updateMapShareSettings({
    field: 'enable_public_' + field + '_link',
    value: on ? 1 : 0,
    onFailure: function onFailure() {
      console.error('failed to update ' + field + ' link settings');
    }
  });
};

this.showPermissionMenu = function () {
  var permissionMenu = _this.refs.permissionMenu;

  _this.isPermissionMenuVisible = true;
  permissionMenu && permissionMenu.classList.remove('floating-menu--hidden');
};

this.hidePermissionMenu = function () {
  var permissionMenu = _this.refs.permissionMenu;

  _this.isPermissionMenuVisible = false;
  permissionMenu && permissionMenu.classList.add('floating-menu--hidden');
};

this.togglePermissionMenu = function (event) {
  event.stopPropagation();

  if (_this.isPermissionMenuVisible) {
    _this.hidePermissionMenu();
  } else {
    _this.showPermissionMenu();
  }
};
});

    
  if (module.hot) {
    module.hot.accept()
    if (module.hot.data) {
      riot.reload('panel-presentation')
    }
  }
  


//////////////////
// WEBPACK FOOTER
// ./starling/src/tags/modal-share/panel-presentation.html
// module id = 763
// module chunks = 0